<template>
  <div class="header-box-mobile-container">
    <div class="content-wrapper">
      <img class="logo" src="https://heartf.oss-cn-zhangjiakou.aliyuncs.com/logo%402x.png" />
      <div class="name-chn">北京心联智成心血管健康公益基金会</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderBoxMobile'
}
</script>

<style lang="scss" scoped>
.header-box-mobile-container {
  width: 100vw;
  height: 0.44rem;
  .content-wrapper {
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    .logo {
      margin-left: 0.2rem;
      width: 0.33rem;
      height: 0.33rem;
    }
    .name-chn {
      margin-left: 0.06rem;
      font-family: PingFangSC-Medium;
      font-size: 0.15rem;
      color: #00B7EE;
      line-height: 0.15rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderBox/Mobile.vue